
export enum ModuleStatus {
  Draft = "draft",
  Published = "published"
}